import { Tooltip, Typography } from '@shinetools/lumen-react'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface BillsTableSuggestedFieldProps {
  value: string
}

/**
 * @todo Handle localization
 * @see https://linear.app/shine-co/issue/EXP-357/web-add-localization
 */
export const BillsTableSuggestedField = ({ value }: BillsTableSuggestedFieldProps): ReactElement => {
  return (
    <Tooltip label="Suggested data, review to confirm.">
      <Styled.TooltipChildWrapper>
        <Typography.Text color="var(--lumen-color-content-neutral-medium)">{value}</Typography.Text>
      </Styled.TooltipChildWrapper>
    </Tooltip>
  )
}
